import type { FormattedPaymentMethod } from '../../../capabilities/checkout/components/Wallet/types';
import type { PaymentMethodType } from '../../../services/commonCheckout/types/PaymentMethod';
import type { StatusChip } from '../type/PaymentMethodButtonTypes';

import {
  createManufacturerStatus,
  createExpiredStatus,
  createDefaultStatus,
  createInvalidStatus,
} from './helperFunctionsToCreateBadges';

const getCardStatuses = (
  paymentMethod: FormattedPaymentMethod<'CARD'>,
): StatusChip[] => {
  const statuses: StatusChip[] = [];

  if (paymentMethod.isManufacturerCard) {
    statuses.push(
      createManufacturerStatus(
        paymentMethod.medication as string,
      ),
    );
  }

  if (paymentMethod.isExpired) {
    statuses.push(
      createExpiredStatus(
        paymentMethod.expirationMonth,
        paymentMethod.expirationYear,
      ),
    );
  }

  return statuses;
};

export const generatePaymentMethodStatus = (
  paymentMethod: FormattedPaymentMethod<PaymentMethodType>,
): StatusChip[] => {
  const statuses: StatusChip[] = [];

  if (paymentMethod.isDefault) {
    statuses.push(createDefaultStatus());
  }

  if (paymentMethod.type === 'CARD') {
    statuses.push(...getCardStatuses(paymentMethod));
  }

  if (paymentMethod.type !== 'CARD' && paymentMethod.isInvalid) {
    statuses.push(createInvalidStatus());
  }

  return statuses;
};
